module.exports = __webpack_public_path__ + "img/mobile-logo_superlive.a3ca9674.svg";